import { Collapse } from "@mui/material";
import moment from "moment";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const StaffCollapsible = ({
  collapseArr,
  setCollapseArr,
  formik,
  dataTitle,
  dataRole,
  item,
  i,
  setSelectedIndex,
  setOpenModal,
}) => {
  const handleClickPreview = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="border rounded-md p-3 w-full shadow-md mb-3 bg-white">
      <div
        className="flex justify-between items-center hover:text-gray-300 cursor-pointer"
        onClick={() =>
          setCollapseArr([
            ...collapseArr.slice(0, i),
            !collapseArr[i],
            ...collapseArr.slice(i + 1),
          ])
        }
      >
        <div>
          <p className="text-[14px] font-semibold">{item.fullname}</p>
          <p>
            {dataTitle && dataTitle.find((title) => title.id === item.title_id)
              ? dataTitle.find((title) => title.id === item.title_id)?.name
              : ""}
          </p>
        </div>
        {collapseArr[i] ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      <Collapse in={collapseArr[i]}>
        <div className="mt-4">
          <button
            type="button"
            className="!rounded-md p-2 border-2 hover:bg-gray-100 w-full border-gray-300 mb-4"
            onClick={() => {
              setSelectedIndex(i);
              setOpenModal(true);
            }}
          >
            Ubah
          </button>

          <div className="mb-2">
            <p>Role Staff</p>
            <p>
              {dataRole
                ? formik.values.staff[i].role
                    .map(
                      (role) =>
                        dataRole.find((roleItem) => roleItem.id === role)?.name
                    )
                    .join(", ")
                : ""}
            </p>
          </div>
          {formik.values.staff[i].title_id === 3 ||
          formik.values.staff[i].title_id === 4 ||
          formik.values.staff[i].title_id === 7 ? (
            <>
              <div className="mb-2">
                <p>Nomor Izin Apoteker/Tenaga Teknis</p>
                <p>{formik.values.staff[i].sipa_id}</p>
              </div>
              <div className="mb-2">
                <p>Masa Berlaku Nomor Izin Apoteker/Tenaga Teknis</p>
                <p>
                  {moment(formik.values.staff[i].sipa_expired).format(
                    "DD MMMM YYYY"
                  )}
                </p>
              </div>
            </>
          ) : null}
          <div className="mb-2">
            <p>No. Handphone</p>
            <p>{formik.values.staff[i].phone}</p>
          </div>
          <div className="mb-2">
            <p>Email</p>
            <p>{formik.values.staff[i].email}</p>
          </div>
          {formik.values.staff[i].title_id === 3 ||
          formik.values.staff[i].title_id === 4 ||
          formik.values.staff[i].title_id === 7 ? (
            <>
              <div className="mb-2">
                <p>No KTP</p>
                <button
                  className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                  onClick={() =>
                    handleClickPreview(formik.values.staff[i].files.ktp)
                  }
                >
                  Lihat Berkas
                </button>
              </div>
              <div className="mb-2">
                <p>Nomor Izin Apoteker/Tenaga Teknis</p>
                <button
                  className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                  onClick={() =>
                    handleClickPreview(formik.values.staff[i].files.izin)
                  }
                >
                  Lihat Berkas
                </button>
              </div>
              <div className="mb-2">
                <p>Spesimen Tanda Tangan</p>
                <button
                  className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                  onClick={() =>
                    handleClickPreview(
                      formik.values.staff[i].files.spesimen_signature
                    )
                  }
                >
                  Lihat Berkas
                </button>
              </div>
            </>
          ) : null}

          {formik.values.staff[i].title_id === 12 ? (
            <>
              <div className="mb-2">
                <p>Surat Izin Praktek TTK</p>
                <button
                  className="border-2 border-gray-300 hover:bg-gray-100 !rounded-md py-2 px-12"
                  onClick={() =>
                    handleClickPreview(
                      formik.values.staff[i].evidence_pharmacist_technician
                        .practice_permit
                    )
                  }
                >
                  Lihat Berkas
                </button>
              </div>
            </>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

export default StaffCollapsible;
